import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import SelectSearch from 'react-select-search';
import Select from "react-select";
import PhoneInput from "react-phone-number-input";
import {
    parsePhoneNumber,
    getCountryCallingCode,
    isValidPhoneNumber,
} from "react-phone-number-input";
// import fuzzySearch from "./fuzzySearch";
import { SignupWithoutOtp, ResendOtp, AskOtp, VerifyOtp } from "../../../redux/actions/AuthAction";

import { useHistory } from "react-router";
import demologo from "../../../assets/demologo.png";
import { useSnackbar } from "react-simple-snackbar";
import { cities } from "./cities";
import { getDevice } from "../../../helpers/PageHelper";
const DemoRegister = ({subject}) => {
    const history = useHistory()
    const dispatch = useDispatch();
    const [openSnackbar, closeSnackbar] = useSnackbar();
    const [name, setName] = useState("");
    const [city, setCity] = useState("");
    const [email, setEmail] = useState("");
    const [errmsg, setErrmsg] = useState("");
    const [callingCode, setCallingCode] = useState("");
    const [statusCode, setStatusCode] = useState("");
    const [resendOTP, setResendOTP] = useState(false);
    const [isWhatsapp, setIswhatsapp] = useState();
    const [isNumber, setIsnumber] = useState();
    const [isEmail, setIsemail] = useState();

    const [numberOremail, setNumberOrEmail] = useState("");
    const [loder, setLoder] = useState(false);
    const [disabledNumber, setDisabledNumber] = useState(false);
    const [internationalNumber, setInternationalNumber] = useState("");
    const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));

    const [otp, setOtp] = useState();
    const [field, setField] = useState("");
    // const [selectedOption, setSelectedOption] = useState("none");
    const options = cities.map((city, i) => ({ value: city, label: city }))

        useEffect(() => {
            if(window.gtag){
            window.gtag("event", "conversion", {'send_to': 'AW-312869085/5K0fCKyDoY0DEN2BmJUB'})
            }
        }, [window.gtag])

    const handleTypeSelect = e => {
        setCity(e.value);
    };

    useEffect(() => {
        if (internationalNumber) {
            const userPhoneNumber = parsePhoneNumber(internationalNumber);

            if (userPhoneNumber) {
                if (isValidPhoneNumber(userPhoneNumber.number)) {
                    const country_calling_code = getCountryCallingCode(
                        userPhoneNumber.country
                    );

                    setCallingCode("+" + country_calling_code);
                    setNumberOrEmail(
                        internationalNumber.replace("+" + country_calling_code, "")
                    );
                }
            }
        }
    }, [internationalNumber]);

    const signupwithoutotp = (e) => {
        e.preventDefault();
        setLoder(true);

        const data = {
            name: name,
            phoneNumber: numberOremail,
            email: email,
            city: city,
            isWebsite: true,
            countryCode: callingCode,
            country: time_zone.country,
            timezone: time_zone.timezone,
            UTMSource:"GOOGLE_PAGE",
            source:getDevice()
        };
        const onSucess = (res) => {
            // makeToast("success", msg);
            setLoder(false);
            console.log(res);
            if (res.status == 200) {
                console.log("it works")
                if(subject !== ":component"){
                    localStorage.setItem("SUBJECT", JSON.stringify(subject));
                }

                localStorage.setItem("LOGIN", JSON.stringify("true"));
                localStorage.setItem("ROLE", JSON.stringify("Learner"));
                localStorage.setItem("IS_LOGOUT", true);
                localStorage.setItem("LOGIN", JSON.stringify("true"));
                localStorage.setItem("ROLE", JSON.stringify("Learner"));
                localStorage.setItem("DEMOUSER", JSON.stringify(res.data.learner));
                localStorage.setItem("TOKEN", JSON.stringify(res.data.learner.token));
                localStorage.setItem("IS_LOGOUT", true);
                localStorage.removeItem("STEP");
                localStorage.removeItem("DATA");
                localStorage.removeItem("NAME");
                openSnackbar("successful");

                history.replace({ pathname: '/google/book-demo/schedule-demo' });
                // window.location.reload();

            }

            else if (res.status == 201) {
                console.log("user exist")
                console.log(res)
                setStatusCode(res.status);
                setIswhatsapp(res.data.learner.isWhatsappNumber);
                setIsnumber(res.data.learner.phoneNumber);
                setIsemail(res.data.learner.email);
               
                openSnackbar("User already exist. Please Login");
                // history.push("/login");

            }

        };
        const onError = (res) => {
            //   setField("password");
            setLoder(false);
            setErrmsg(res);
            openSnackbar("Enter a valid number")

            console.log(res)
        };
        dispatch(SignupWithoutOtp(data, onSucess, onError));
    };

    //askOTP
    const askforOtp = () => {
        // ResendOtp
        if (numberOremail) {
            const data = {
                phoneNumber: numberOremail,
            };
            const onSuccess = () => {
                openSnackbar("OTP sent Successfully");
            };

            const onError = (msg) => {
                openSnackbar(msg);
            };
            dispatch(AskOtp(data, onSuccess, onError));
        } else {
            openSnackbar("something went wrong");
        }
    };

    //resend OTP
    const resendOtp = () => {
        // ResendOtp
        if (numberOremail) {
            const data = {
                phoneNumber: numberOremail,
            };
            const onSuccess = () => {
                openSnackbar("OTP sent Successfully");
            };

            const onError = (msg) => {
                openSnackbar(msg);
            };
            dispatch(ResendOtp(data, onSuccess, onError));
        } else {
            openSnackbar("Please Enter Phone number or Email");
        }
    };

    useEffect(() => {
        if (statusCode == 201) {
            askforOtp();
        }
    }, [statusCode]);

    //verifyotp

    const verifyOTP = (e) => {
        e.preventDefault();
        setLoder(true);

        var data = {
            OTP: otp,

        };


        const onSuccess = (res) => {
            console.log(res);
            openSnackbar(res.data.message);
            setLoder(false);
            localStorage.removeItem("IS_LOGOUT");
            localStorage.setItem("USER", JSON.stringify(res.data.learner));
            localStorage.setItem("TOKEN", JSON.stringify(res.data.learner.token));
            localStorage.setItem("LOGIN", JSON.stringify("true"));
            localStorage.setItem("IS_LOGOUT", JSON.stringify(true));
            localStorage.setItem("ROLE", JSON.stringify("Learner"));

            history.push("/dashboard");
            // window.location.reload();
            // history.push("/dashboard");

        };
        const onError = (msg) => {
            setField("otp");
            openSnackbar(msg);
            setLoder(false);
            setErrmsg(msg);
        };


        dispatch(VerifyOtp(data, onSuccess, onError));


    };
    console.log(isEmail);
    console.log(isNumber);
    console.log(isWhatsapp);

    const submitExcel = async (e) => {
        e.preventDefault();
        console.log("GOOGLE")
        try {

            
                const response = await fetch('https://v1.nocodeapi.com/clapingo123/google_sheets/vOAMdPpmvKDzKqQC?tabId=Sheet1', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify([[name, numberOremail, email,city, new Date().toLocaleString()]])
                });

                await response.json()
                

            

        } catch (err) {
            console.log(err)
        }
    }
    return (
        <div>
            {statusCode == 201 ?
                <div className="text-center">
                    <h3 style={{color:"#24A791"}}>Please enter the OTP to continue login</h3>
                    <p>OTP sent to your registered {isEmail? "Email, ":""}{isNumber? "Sms, ":""}{isWhatsapp? "Whatsapp":""}.<br/> Please verify your OTP.</p>
                    <input
                        className="input "
                        style={{width:"30%"}}
                        placeholder="6-digit OTP"
                        type="number"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        required
                    />
                    {/* <label className="invalid_message"></label> */}
                    <br />
                    {/* {field === "otp" ? (
                        <label className="invalid_message ">{errmsg}</label>
                    ) : (
                        ""
                    )} */}
                    <br />
                    {resendOTP ? (
                        <p
                            className="text-danger "
                            id="some_div"
                            style={{ textAlign: "center" }}
                        ></p>
                    ) : (
                        <p
                            style={{ textAlign: "center", cursor: "pointer", color:"red" }}
                            onClick={() => {
                                // setResendOTP(true);
                                resendOtp();
                            }}
                            
                        >
                            Resend OTP ?
                        </p>)}
                    <button
                    disabled={!otp ? true : false}
                    style={{width:"150px", height:"50px"}}
                    className={loder ? "continueBTNdisabled btn-block mx-auto " : "continueBTN btn-block  mx-auto "}
                    onClick={(e) => verifyOTP(e)}>Verify OTP</button>
                </div>

                :

                <form onSubmit={(e) => { signupwithoutotp(e); submitExcel(e); }}>

                    <div className="demo-form">
                        <div class="form-group mt-3">
                            <label >

                                <div className="mb-2">
                                    <img width="122px" height="32px" src={demologo} alt="clapingologo" />
                                </div>
                                <p
                                    className="headingfont"
                                >
                                    Book a Trial
                                </p>
                                <p className="subtitle">Book your 15 min. trial @ ₹99.</p>
                            </label>

                            <div className="form-row">
                                <div className="col">
                                    <label>Name</label>
                                    <input
                                        id="fname"
                                        type="text"
                                        className="form-control RegInput "
                                        placeholder="Full name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="col">
                                    <label>City</label>
                                    {/* <input
                                    id="cityfield"
                                    type="text"
                                    className="form-control RegInput"
                                    placeholder="City"
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                    required
                                /> */}
                                    {/* <SelectSearch
                                    options={options}
                                    search
                                    filterOptions={fuzzySearch}
                                    placeholder="City"
                                    value={city}
                                    onChange={(e) => console.log(e)}
                                /> */}

                                    <div>
                                        <Select
                                            options={options}
                                            onChange={handleTypeSelect}
                                            value={options.filter(function (option) {
                                                return option.value === city;
                                            })}
                                            label="Single select"
                                        />
                                    </div>
                                </div>

                            </div>
                            <div className="form-row mt-3">

                                <div className="col">

                                    <label>Phone Number</label>

                                    <PhoneInput
                                        placeholder="Enter Mobile number"
                                        className="form-control RegInput d-flex"
                                        international
                                        countryCallingCodeEditable={false}
                                        defaultCountry={time_zone.country}
                                        // country={time_zone.country}
                                        value={internationalNumber}
                                        onChange={setInternationalNumber}
                                        disabled={disabledNumber}
                                        required

                                    />

                                </div>
                                <div className="col ">
                                    <div className="phoneinput">
                                        <label>Email id</label>
                                        <input
                                            id="cityfield"
                                            type="email"
                                            className="form-control RegInput"
                                            placeholder="abc@gmail.com"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>

                            </div>


                            <p className="text-center mt-2" style={{ color: "red" }}>{errmsg}</p>

                            <button
                                type="submit"
                                // onClick={()=>history.replace({ pathname: 'schedule-demo'})}
                                disabled={loder ? true : false}

                                className={loder ? "continueBTNdisabled btn-block mx-auto mt-5" : "continueBTN btn-block  mx-auto mt-5"}

                            >
                                {loder ? (
                                    "Loading ..."
                                ) : (
                                    "Book a Trial"
                                )}
                            </button>

                            {/* <p className="text-center mt-1 text-danger">{errormsg}</p> */}


                        </div>
                    </div>
                </form>

            }


        </div>

    )
}

export default DemoRegister;
